import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocationDot, faCheese } from "@fortawesome/free-solid-svg-icons";

const lacteos = [
  {
    nombre: "La Manchita Lácteos",
    link: "https://maps.app.goo.gl/hu4xz8cDiiA831hf8",
    direccion: (
      <>
        Almirante Brown 349.<br />
        3532-416560
      </>
    ),
  },
];

const Lacteos = () => (
  <div className="content-tab">
    <div className="row">
      <div className="col-12 col-md-6">
        <h5>
          <FontAwesomeIcon icon={faCheese} style={{ color: "#f4d35e", marginRight: 8 }} />
          Lácteos
        </h5>
        <ul className="lista-referencias">
          {lacteos.map((item, i) => (
            <li key={i}>
              <FontAwesomeIcon icon={faMapLocationDot} style={{ color: "#2980b9", marginRight: 8 }} />
              <a href={item.link} target="_blank" rel="noopener noreferrer">
                {item.nombre}
              </a>
              <div className="ms-2 me-auto">{item.direccion}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

export default Lacteos;